module.exports = __webpack_public_path__ + "static/media/logo.54c555cd.png";